import Button from '../../Button';
import { ButtonsContainer, Container, Title } from './styles';

type PostModalProps = {
  onAction: any;
};

export default function DeleteModal({ onAction }: PostModalProps) {
  return (
    <Container>
      <Title>Quer mesmo excluir este post?</Title>
      <ButtonsContainer>
        <Button height={44} text="Sim" theme='light' onClick={() => onAction('confirmDelete')} />
        <Button height={44} text="Não" theme='dark' onClick={() => onAction('noDelete')} />
      </ButtonsContainer>
    </Container>
  );
}